import { ProcessorName } from '@consigli/types';

export interface FindingsFilterState {
  processorName: ProcessorName | undefined;
  blobIds: string[];
  labels: string[];
  search: string;
  reference: string | undefined;
}

export const emptyFindingsFilterState: FindingsFilterState = {
  processorName: undefined,
  blobIds: [],
  labels: [],
  search: '',
  reference: undefined,
};

export const hasActiveFindingsFilter = (filters: FindingsFilterState): boolean =>
  filters.processorName !== undefined ||
  filters.blobIds.length > 0 ||
  filters.labels.length > 0 ||
  filters.search.trim().length > 0 ||
  filters.reference !== undefined;
